// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView, MobileLayout } from '@/layouts'

/**
 * 基础路由
 * @type { *[] }
 */
export const pcRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',

    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      }
    ]
  },
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '极星云码' },
    redirect: '/dashboard',
    children: [
      // 首页
      {
        path: '/dashboard',
        name: 'dashboard',
        component: PageView,
        redirect: '/dashboard/index',
        meta: { title: '首页', icon: 'desktop' },
        hideChildrenInMenu: true,
        children: [
          {
            path: '/dashboard/index',
            name: 'Dashboard',
            component: () => import('@/views/dashboard/dashboard'),
            meta: { title: '概览', keepAlive: true, hiddenPageTitle: true, hiddenHeaderContent: true }
          },
          {
            path: '/dashboard/securityCodeDetail',
            name: 'securityCodeDetail',
            component: () => import('@/views/dashboard/securityCodeDetail'),
            meta: { title: '云码详情', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          },
          {
            path: '/dashboard/customPageAdd',
            name: 'customPageAdd',
            component: () => import('@/views/dashboard/customPageAdd'),
            meta: { title: '新增页面', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          },
          {
            path: '/dashboard/customPageEdit',
            name: 'customPageEdit',
            component: () => import('@/views/dashboard/customPageEdit'),
            meta: { title: '编辑页面', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          },
          {
            path: '/dashboard/printCode',
            name: 'printCode',
            component: () => import('@/views/dashboard/printCode'),
            meta: { title: '打印云码', keepAlive: false, hiddenPageTitle: false, permission: ['user'] }
          }
        ]
      },
      // 商品管理
      {
        path: '/goodsManage',
        name: 'goodsManage',
        component: PageView,
        redirect: '/goodsManage/goodsList',
        meta: { title: '商品管理', icon: 'appstore' },
        hideChildrenInMenu: false,
        children: [
          {
            path: '/goodsManage/goodsList',
            name: 'goodsList',
            component: () => import('@/views/goodsManage/goodsList'),
            meta: { title: '商品列表', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          },
          {
            path: '/goodsManage/goodsTypeList',
            name: 'goodsTypeList',
            component: () => import('@/views/goodsManage/goodsTypeList'),
            meta: { title: '商品分类', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          },
          {
            path: '/goodsManage/goodsAdd',
            name: 'goodsAdd',
            component: () => import('@/views/goodsManage/goodsAdd'),
            hidden: true,
            meta: { title: '新增商品', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          },
          {
            path: '/goodsManage/goodsEdit',
            name: 'goodsEdit',
            component: () => import('@/views/goodsManage/goodsEdit'),
            hidden: true,
            meta: { title: '编辑商品', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          }
        ]
      },
      // 打印管理
      {
        path: '/printManage',
        name: 'printManage',
        component: PageView,
        redirect: '/printManage/printHistory',
        meta: { title: '打印管理', icon: 'printer' },
        hideChildrenInMenu: false,
        children: [
          {
            path: '/printManage/printHistory',
            name: 'printHistory',
            component: () => import('@/views/printManage/printHistory'),
            meta: { title: '打印订单', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          },
          {
            path: '/printManage/orderDetail',
            name: 'orderDetail',
            component: () => import('@/views/printManage/orderDetail'),
            hidden: true,
            meta: { title: '订单详情', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          },
          {
            path: '/printManage/printMould',
            name: 'printMould',
            component: () => import('@/views/printManage/printMould'),
            meta: { title: '打印模板', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          },
          {
            path: '/printManage/printMouldAdd',
            name: 'printMouldAdd',
            component: () => import('@/views/printManage/printMouldAdd'),
            hidden: true,
            meta: { title: '新建模板', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          },
          {
            path: '/printManage/printMouldEdit',
            name: 'printMouldEdit',
            component: () => import('@/views/printManage/printMouldEdit'),
            hidden: true,
            meta: { title: '编辑模板', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          }
        ]
      },
      // 售后管理
      {
        path: '/saleManage',
        name: 'saleManage',
        component: PageView,
        redirect: '/saleManage/memberRecodeList',
        meta: { title: '售后管理', icon: 'message' },
        hideChildrenInMenu: false,
        children: [
          {
            path: '/saleManage/memberRecodeList',
            name: 'memberRecodeList',
            component: () => import('@/views/saleManage/memberRecodeList'),
            meta: { title: '会员登记', keepAlive: false, hiddenPageTitle: false, permission: ['user'] }
          },
          {
            path: '/saleManage/feedbackList',
            name: 'feedbackList',
            component: () => import('@/views/saleManage/feedbackList'),
            meta: { title: '售后反馈', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          }
        ]
      },
      // 延保管理
      {
        path: '/maintainManage',
        name: 'maintainManage',
        component: PageView,
        redirect: '/maintainManage/maintainSetting',
        meta: { title: '延保管理', icon: 'heart' },
        hideChildrenInMenu: false,
        children: [
          {
            path: '/maintainManage/maintainSetting',
            name: 'maintainSetting',
            component: () => import('@/views/maintainManage/maintainSetting'),
            meta: { title: '延保设置', keepAlive: true, hiddenPageTitle: false, permission: ['user'] }
          },
          {
            path: '/maintainManage/maintainList',
            name: 'maintainList',
            component: () => import('@/views/maintainManage/maintainList'),
            meta: { title: '延保列表', keepAlive: false, hiddenPageTitle: false, permission: ['user'] }
          }
        ]
      },
      // 报修管理
      {
        path: '/repairManage',
        name: 'repairManage',
        component: PageView,
        redirect: '/repairManage/index',
        meta: { title: '报修管理', icon: 'alert' },
        hideChildrenInMenu: false,
        children: [
          {
            path: '/repairManage/index',
            name: 'repairManageIndex',
            component: () => import('@/views/repairManage/Index'),
            meta: { title: '报修列表', keepAlive: false, hiddenPageTitle: false }
          },
          {
            path: '/repairManage/notice',
            name: 'repairManageNotice',
            component: () => import('@/views/repairManage/Notice'),
            meta: { title: '通知管理', keepAlive: false, hiddenPageTitle: false }
          }
        ]

      },
      // 资产管理
      {
        path: '/propertyManage',
        name: 'propertyManage',
        component: PageView,
        redirect: '/propertyManage/index',
        meta: { title: '资产管理', icon: 'account-book' },
        hideChildrenInMenu: true,
        children: [
          {
            path: '/propertyManage/index',
            name: 'PropertyManageIndex',
            component: () => import('@/views/propertyManage/index'),
            meta: { title: '资产管理', keepAlive: true, hiddenPageTitle: true, hiddenHeaderContent: true }
          }
        ]
      },
      // 用户管理
      {
        path: '/member',
        name: 'member',
        component: PageView,
        redirect: '/member/index',
        meta: { title: '用户管理', icon: 'user' },
        hideChildrenInMenu: true,
        children: [
          {
            path: '/member/index',
            name: 'memberIndex',
            component: () => import('@/views/member/Index'),
            meta: { title: '用户管理', keepAlive: false, hiddenPageTitle: true, hiddenHeaderContent: true }
          }
        ]
      },
      // 品牌管理
      {
        path: '/brand',
        name: 'brand',
        component: PageView,
        redirect: '/brand/index',
        meta: { title: '品牌管理', icon: 'sketch' },
        hideChildrenInMenu: true,
        children: [
          {
            path: '/brand/index',
            name: 'brandIndex',
            component: () => import('@/views/brand/Index'),
            meta: { title: '品牌管理', keepAlive: false, hiddenPageTitle: true, hiddenHeaderContent: true }
          }
        ]
      },
      // 协议管理
      {
        path: '/agreementManage',
        name: 'agreementManage',
        component: PageView,
        redirect: '/agreementManage/index',
        meta: { title: '协议管理', icon: 'file-text' },
        hideChildrenInMenu: true,
        children: [
          {
            path: '/agreementManage/index',
            name: 'agreementManageIndex',
            component: () => import('@/views/agreementManage/index'),
            meta: { title: '协议管理', keepAlive: true, hiddenPageTitle: true, hiddenHeaderContent: true }
          }
        ]
      },
      // 系统设置
      {
        path: '/system',
        name: 'system',
        // component: () => import('@/views/system/Index'),
        component: PageView,
        meta: { title: '系统管理', icon: 'setting', permission: ['form'] },
        redirect: '/system/base',
        hideChildrenInMenu: false,
        children: [
          {
            path: '/system/base',
            name: 'base',
            component: () => import('@/views/system/base/Setting'),
            meta: { title: '系统设置', keepAlive: true, permission: ['user'] },
            redirect: '/system/base/account',
            hideChildrenInMenu: true,
            children: [
              {
                path: '/system/base/system',
                name: 'System',
                component: () => import('@/views/system/base/System'),
                meta: { title: '企业信息', keepAlive: true, permission: ['user'] }
              },
              {
                path: '/system/base/account',
                name: 'Account',
                component: () => import('@/views/system/base/Account'),
                meta: { title: '账号信息', keepAlive: true, permission: ['user'] }
              }
              // {
              //   path: '/system/base/Sms',
              //   name: 'Sms',
              //   component: () => import('@/views/system/base/Sms'),
              //   meta: { title: '短信配置', keepAlive: true, permission: ['user'] }
              // },
              // {
              //   path: '/system/base/wxapp',
              //   name: 'Wxapp',
              //   component: () => import('@/views/system/base/Wxapp'),
              //   meta: { title: '微信小程序配置', keepAlive: true, permission: ['user'] }
              // },
              // {
              //   path: '/system/base/pagenow',
              //   name: 'Pagenow',
              //   component: () => import('@/views/system/base/Pagenow'),
              //   meta: { title: '数据大屏配置', keepAlive: true, permission: ['user'] }
              // },
              // {
              //   path: '/system/base/oss',
              //   name: 'Oss',
              //   component: () => import('@/views/system/base/Oss'),
              //   meta: { title: '阿里云OSS配置', keepAlive: true, permission: ['user'] }
              // }
            ]
          // },
          // {
          //   path: '/system/role',
          //   name: 'role',
          //   component: () => import('@/views/system/Role'),
          //   meta: { title: '角色管理', keepAlive: true, permission: ['user'] }
          // },
          // {
          //   path: '/system/admin',
          //   name: 'admin',
          //   component: () => import('@/views/system/Admin'),
          //   meta: { title: '管理员管理', keepAlive: true, permission: ['user'] }
          }
        ]
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export const mobileRouterMap = [
  {
    path: '/merchant',
    component: { render: (e) => e('router-view') },
    redirect: '/merchant/login',
    hidden: true,
    children: [
      {
        path: '/merchant/login',
        name: 'login',
        component: () => import('@/mobile/merchant/login')
      }
    ]
  },
  {
    path: '/m',
    redirect: '/repair',
    // component: { render: (e) => e('router-view') },
    component: MobileLayout,
    hidden: true,
    children: [
      {
        path: '/repair',
        redirect: '/m_repair/repairManage',
        hidden: true,
        component: { render: (e) => e('router-view') },
        children: [
          {
            path: '/m_repair/repairManage',
            name: 'repairManage',
            component: () => import('@/mobile/repair/repairManage'),
            meta: { title: '报修详情', permission: ['merchant'] }
          }
        ]
      }
    ]
  }
]

export const constantRouterMap = pcRouterMap.concat(mobileRouterMap)
